'use client';

import { useLocale } from 'next-intl';

import DE from './de';
import EN from './en';
import ES from './es';
import FI from './fi';
import FR from './fr';
import IT from './it';
import JP from './jp';

const Content = (): JSX.Element => {
  const selectedLocale = useLocale();

  switch (selectedLocale) {
    case 'de':
      return <DE />;
    case 'es':
      return <ES />;
    case 'fi':
      return <FI />;
    case 'it':
      return <IT />;
    case 'fr':
      return <FR />;
    case 'ja':
      return <JP />;
    default:
      return <EN />;
  }
};

export default Content;
